import React from 'react';
import './ElevationSettings.css';

const ElevationSettings = ({ currentElevation, onElevationChange }) => {
  // Derive state from props (Controlled Component pattern)
  const elevation = currentElevation || 295;

  // Preset configurations
  const presets = [
    { label: 'Field-Tested', value: 295, description: 'Recommended (Tested)' },
    { label: 'WGS84 (Theoretical)', value: 300.6, description: 'Calculated' },
    { label: 'MSL (Legacy)', value: 337, description: 'Old/Incorrect' },
  ];

  // Check if current value matches any preset
  const isPresetValue = presets.some(preset => preset.value === elevation);
  const customMode = !isPresetValue;

  const handlePresetClick = (value) => {
    onElevationChange(value);
  };

  const handleCustomInput = (e) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      onElevationChange(value);
    }
  };

  const handleReset = () => {
    onElevationChange(295);
  };

  return (
    <div className="elevation-settings">
      <div className="elevation-header">
        <h3>Ground Elevation</h3>
        <div className="current-value">
          {elevation.toFixed(1)}m
        </div>
      </div>

      <div className="elevation-presets">
        {presets.map((preset) => (
          <button
            key={preset.value}
            className={`preset-button ${elevation === preset.value ? 'active' : ''}`}
            onClick={() => handlePresetClick(preset.value)}
          >
            <div className="preset-label">{preset.label}</div>
            <div className="preset-value">{preset.value}m</div>
            <div className="preset-description">{preset.description}</div>
          </button>
        ))}
      </div>

      <div className="custom-input-section">
        <label htmlFor="custom-elevation">Custom Value (250-400m):</label>
        <div className="input-group">
          <input
            id="custom-elevation"
            type="number"
            min="250"
            max="400"
            step="0.1"
            value={customMode ? elevation : ''}
            onChange={handleCustomInput}
            placeholder="Enter custom value"
            className={customMode ? 'active' : ''}
          />
          <span className="unit">m</span>
        </div>
      </div>

      <div className="elevation-actions">
        <button className="reset-button" onClick={handleReset}>
          Reset to Default
        </button>
      </div>

      <div className="elevation-info">
        <div className="info-icon">ℹ️</div>
        <div className="info-text">
          Ground elevation affects altitude calculation for GPS waypoints.
          Use Field-Tested value (295m) for accurate results.
        </div>
      </div>
    </div>
  );
};

export default ElevationSettings;
